import AmericanBankerLogo from '../../assets/AmericanBanker'
import abArticle from './American Banker-The tech Sunrise Bank used to quickly dole out PPP loans.pdf'

const americanBanker = {
  getImage: (props) => (
    <AmericanBankerLogo className="american-banker" {...props} />
  ),
  getURL: (variant) => abArticle,
}

export default americanBanker
